import styled from "styled-components";

export const ModifyHeader = styled.div(
  (props) => `
		min-width: ${ props.isCharDham ? 'fit-content' : props?.isMulticity ? "154rem" : "144rem"};
  	display: flex;
    height: 8.6rem;
    padding: ${props.isCharDham ? "1.2rem" : props.padding ? props.padding : '1.2rem 0 1.2rem 1.2rem'} ;
    object-fit: contain;
		background-color: ${props.theme.colors.goBrand.orange};
		justify-content: center;
	border-radius: ${ props?.isCharDham ? '16px' : '0'};
	${props.isCharDham ? 'transition: all 0.3s ease-in-out;' : ''}
   ${props.isSticky && props?.isCharDham &&
    `
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 1000;
	  border-radius: 0;
    `}
`
);

export const TripType = styled.div`
	width: 10rem;
	height: 1.6rem;
	margin: 0rem 14rem 0.4rem 0rem;
	padding: 0rem 2.5rem 0rem 0rem;
	object-fit: contain;
`;

export const WidgetType = styled.div(
  (props) => `
		width: ${props.width};
		height: 1.6rem;
		padding: 0rem 2.5rem 0rem 0rem;
		border-radius: 0.8rem;
		margin-right: ${props.marginRight || "0"};
		background-color: ${props.theme.colors.goBrand.orange};	
	`);

export const TripTypeTxt = styled.p(
	props => `
		font-stretch: normal;
		font-style: normal;
		letter-spacing: normal;
		font-family: ${props.theme.font.fontFamily};
		font-size: 1.2rem;
		font-weight: normal;
		line-height: 1.33;
		width: 11rem;
		color: ${props.theme.colors.white.base};
	`
);

export const StopoversTextCont = styled.div`
	justify-content: center;
	font-size: 1.6rem;
	font-weight: 500;
	color: #fff;
	height: 4.2rem;
	margin-top: 2rem;
	margin-right: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 10rem;
	background: #FFF;
	color: #2274E0;
	border-radius: 0.8rem;
	position: relative;
	cursor: pointer;
	 
	.btn-gradient-1 {
		background: linear-gradient(white, white) padding-box,
		linear-gradient(to right, darkblue, darkorchid) border-box;
		border-radius: 6px;
		border: 1px solid transparent;
		display: inline-block;
		position: absolute;
		top: -10px;
		padding: 1px 4px;
		right: 4px;
	}
	 
	.btn-gradient-1 p {
		background: linear-gradient(red, blue);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
		font-size: 12px;
	}
`;

export const OutStandingWarpper = styled.div(
	props => `
		flex-direction: 'row';
		width: ${props.width};
		height: 4.2rem;
		margin: 0.4rem 1rem 0.0rem 0.0rem;
		padding: 0.9rem 1.2rem 1.1rem 1rem;
		border-radius: 0.8rem;
		background-color: ${props.theme.colors.white.base};
		cursor: pointer;
		display: flex;
	`
);

export const TooltipContainer = styled.div`
	position: absolute;
	background-color: #222222;
	border-radius: 4px;
	z-index: 1;
	padding-top: 8px;
	padding-bottom: 8px;
	padding-left: 12px;
	padding-right: 12px;
	top: 135%;
	left: 30%;
	transform: translateX(-50%);
	width: 300px;
`;

export const TooltipArrow = styled.div`
	position: absolute;
	top: -10px;
	left: 45%;
	transform: translateX(-50%);
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 10px solid #222222;
`;

export const TooltipText = styled.span`
	color: white;
	font-size: 14px;
`;

export const ColumnContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 14rem;
`;

export const SmallText = styled.span`
  	font-size: 12px;
	color:white;
`;

export const BoldText = styled.span`
  	font-weight: 900;
	color:white;
`;

export const ReturnTimeContainer = styled.div`
	position: relative;
	display: inline-block;
`

export const RTTimeWrapper = styled.div(
  props => `
  flex-direction: 'row';
  width: ${props.width}
  height: 4.2rem;
  margin: 0.4rem 1rem 0.0rem 0.0rem;
  cursor: pointer;
  display: flex;
  padding-left: 1rem;
`)



export const OutStandingInner = styled.p(
	props => `
		height: 2.2rem;
		font-family: 'Rubik';
		font-size: 1.6rem;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.38;
		letter-spacing: normal;
		color: ${props.theme.colors.black.base};
		flex: 1;
		`
);

export const ArrowIcon = styled.div`
	align-content: flex-end;
	justify-content: flex-end;
	padding-top: 0.9rem;
`;

export const OutStandingInputInner = styled.input.attrs(props => (
	{
		...props, 
		...{
			autoFocus: props?.autoFocus || false
		}
	}
))(p => `
		width: ${p.width};
		height: 2.2rem;
		margin: 0 0.7rem 0 0;
		font-family: 'Rubik';
		font-size: 1.6rem;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		border-width:0px;
		border:none;		
		line-height: 1.38;
		letter-spacing: normal;
		background-color: #fff;
		border:none;
	`);

export const UpdateButton = styled.div`
	width: 18.6rem;
  height: 4.2rem;
  margin: 1.7rem 0rem 0.0rem 0.5rem;
  padding: 0.8rem 0.0rem 1rem;
  border-radius: 0.8rem;
	background-color: #ffffff;
	cursor: pointer;
`;

export const updateButtonTxt = styled.p`
	font-family: 'Rubik';
	font-size: 1.8rem;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.33;
	letter-spacing: normal;
	text-align: center;
	color: #2276E3;
	;
`

export const ErrorWrapper = styled.div`
	position: absolute;
`;

export const TripTypeSelection = styled.div(
  (props) => `
  top: ${props.top}rem;
  background: white;
  box-shadow: 0 2px 14px 0 rgba(0,0,0,0.16);
  border-radius: 1.2rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 30rem;
  z-index: 7;
  max-height: 48rem;
  overflow-y: scroll;`
);

export const ArrowDownIcon = styled.div`
    flex-shrink: 0;
    margin-left: auto;
		font-family: 'Rubik';
		font-size: 1.6rem;
		color: #2276e3;
		display: flex;
		align-items: center;
		font-weight: 600;
		cursor: pointer;
		::after{
			content: "";
			border: solid #141823;
			border-width: 0 0.2rem 0.2rem 0;
			padding: 0.5rem;
			transform: rotate(45deg);
			margin-left: 1rem;
			margin-top: -0.5rem;
		}
`;
